import * as NavConst from '../components/constants/NavigationConstants';
import * as SweetAlert from '../components/common/utilities/ConfirmationAlert';
import { GENERIC_PAGINATED_KEY_VALUE_LIST, getApiPath, DELETE, USER, CLIENT_USER_ACCESS, LIST } from '../api/ApiConst';
import apiCaller from "../api/ApiCaller";

export const UserClientAccess = {
  basePath: "client-user-access",
  tableDataUrl:LIST,
  label: "User access to client",
  attributes: [{ name: "id", value: "id", type: "text", position: 0, formAttribute: false },
  { name: "clientId", value: "clientId", type: "text", position: 1, formAttribute: false },
  { name: "username", value: "username", type: "text", position: 1, formAttribute: false },
  {
    name: "User", value: "userId", type: "select", position: 2, formAttribute: true, isStatic: false, basePath: "user",
    dataListFunction: () => {
      const options = []
      var jsonRequest = { "page": 0, "size": 200, searchFilters: [], sortRules: [] };
      apiCaller.callPostApi(getApiPath(USER, GENERIC_PAGINATED_KEY_VALUE_LIST), jsonRequest, {}, (response) => {
        response.data.map((d) => {
          options.push({ value: d.key, label: d.value })
        });
      }, (error) => {
        console.error(error);
      });
      return options
    }
  },
  {
    name: "Type", value: "type", type: "select", position: 3, formAttribute: true, isStatic: true, dataList: [
      { value: "READ", label: "READ" },
      { value: "WRITE", label: "WRITE" },
      { value: "READ_WRITE", label: "READ_WRITE" }

    ],
    className: "form-control input-default"
  }
  ],
  actions: [
    { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.UPDATE_TABLE_STRUCTURE, replaceData: ":updateTableName" },
    {
      name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
      navigatePath: getApiPath(CLIENT_USER_ACCESS, DELETE), replaceData: "{recordId}"
    },
    { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
    { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
  ]
};



